import { object } from "yup";
import { EmailSchema } from "@validation/user";

export const initialValues = { email: "" };

export const validationSchema = object().shape({
  email: EmailSchema,
});
